import React, { useState } from "react";
import FacebookIcon from "../../../images/fb-gray.svg";
import TwitterIcon from "../../../images/twitter-gray.svg";
import LinkedInIcon from "../../../images/linkedin-gray.svg";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from "react-share";
import { Box, IconButton, Menu, Stack } from "@mui/material";
import { Share } from "@mui/icons-material";

const ShareComponent = ({ url, className }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton className={className} onClick={handleMenuOpen}>
        <Share color="primary" />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Stack
          direction="row"
          sx={{ alignItems: "center", px: "5px" }}
          gap="5px"
        >
          <FacebookShareButton url={url}>
            <IconButton size="small" component={Box}>
              <Box
                component="img"
                src={FacebookIcon}
                sx={{ height: "18px", width: "18px", color: "red" }}
              />
            </IconButton>
          </FacebookShareButton>

          <LinkedinShareButton url={url}>
            <IconButton size="small" component={Box}>
              <Box
                component="img"
                src={LinkedInIcon}
                sx={{ height: "18px", width: "18px", color: "red" }}
              />
            </IconButton>
          </LinkedinShareButton>

          <TwitterShareButton url={url}>
            <IconButton size="small" component={Box}>
              <Box
                component="img"
                src={TwitterIcon}
                sx={{ height: "18px", width: "18px", color: "red" }}
              />
            </IconButton>
          </TwitterShareButton>
        </Stack>
      </Menu>
    </>
  );
};

export default ShareComponent;
